import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../../components/componentsGeneral/AnimatedView/AnimatedView';
import InventoryPalletCaseSkuContainer from '../../../../components/componentsInventoryManagement/_Lot_Tracking_Components/InventoryPalletCaseSku/InventoryPalletCaseSkuContainer';
import { Message } from 'rsuite';
import { lotTrackingWarehouseIDs } from '../../../../app/appConfig';

class invManInventoryPalletCaseSkuView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
    componentDidMount() {

    }

    render() {

        if (!lotTrackingWarehouseIDs.includes(this.props.warehouseSelection) && !lotTrackingWarehouseIDs.includes("All")) {
            return <AnimatedView><Message style={{ marginTop: '25px' }} type="info" description="Please only select Lot Tracking warehouses" /></AnimatedView>;
        }

        return (
            <AnimatedView>
                <InventoryPalletCaseSkuContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default invManInventoryPalletCaseSkuView;
